import { z } from "zod"

import { WarehouseShelvingBinSize } from "@/graphql/codegen/graphql"

export const WarehouseShelvingFormSchema = z
  .object({
    coldStorage: z
      .boolean()
      .nullable()
      .refine((value): boolean | null => value !== null, { message: "Select Cold Storage option" }),
    h3ColdStorage: z.boolean().nullable(),
    binSize: z.union([z.nativeEnum(WarehouseShelvingBinSize), z.string().min(1, { message: "Bin Size is required" })]),
    deep: z
      .boolean()
      .nullable()
      .refine((value): boolean | null => value !== null, { message: "Select Deep Storage option" }),
    doNotUse: z.boolean(),
  })
  .superRefine((values, ctx) => {
    if (values.coldStorage && values.h3ColdStorage === null) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Select H3 Storage option",
        path: ["h3ColdStorage"],
      })
    }
  })

export type WarehouseShelvingFormValues = z.infer<typeof WarehouseShelvingFormSchema>
